import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Esto es para mí si tengo dudas?',
  a: 'Sí. El plan está diseñado para cuando dudas. Te guía paso a paso.'
}, {
  q: '¿Cuánto tiempo al día necesito?',
  a: '10-15 minutos. Rutina AM/PM corta y acción diaria.'
}, {
  q: '¿Cuándo veo cambios?',
  a: 'Depende de tu constancia. Algunas notan cambios en días, otras en semanas.'
}, {
  q: '¿Puedo enfocarme en dinero y amor a la vez?',
  a: 'Sí. El vision board se divide por categorías.'
}, {
  q: '¿Cómo recibo el ebook?',
  a: 'Inmediato después del pago. Es digital (PDF).'
}, {
  q: '¿Esto reemplaza terapia o ayuda profesional?',
  a: 'No. Es una guía de desarrollo personal, no tratamiento médico.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-8 bg-white" data-id="element-35">
      <div className="max-w-3xl mx-auto px-4" data-id="element-36">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2B0A3D] text-center mb-8" data-id="element-37">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-38">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-39">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-40">
                <span className="font-medium text-[#2B0A3D] text-lg" data-id="element-41">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-42" />
              </button>
              <AnimatePresence data-id="element-43">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-44">
                    <div className="p-5 pt-0 text-gray-600 bg-white border-t border-gray-100" data-id="element-45">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}